import React from 'react';
import Navbar from '../Shared/Navbar';
import Showcase from './Showcase';
import heroBg from '../../assets/hero-bg.mp4';
import curveBorder from '../../assets/underline.svg';
import TopPlaces from './TopPlaces';
import TopGuides from './TopGuides';
import Partners from './Partners';
import Services from './Services';

const Home = () => {
    return (
        <div className='w-full'>
            <video className='video-bg' src={heroBg} autoPlay loop muted></video>
            <div className='absolute top-0 w-full'>
                <Navbar currentPage={'home'} />
                <Showcase />
            </div>
            <Services />
            <TopPlaces />
            <div className='my-32'>
                <div className='my-8 flex flex-col items-center'>
                    <h1 className='text-4xl font-bold text-center'>Our Trusted Guides</h1>
                    <img className='block w-40' src={curveBorder} alt="curve underline" />
                </div>
                <TopGuides />
            </div>
            <div className='my-32'>
                <div className='my-8 flex flex-col items-center'>
                    <h1 className='text-4xl font-bold text-center'>Our Top Rated Allies</h1>
                    <img className='block w-40' src={curveBorder} alt="curve underline" />
                </div>
                <Partners />
            </div>
        </div>
    );
};

export default Home;